import { Element, Node, Text, Editor } from 'slate';

/**
 * Normalize the descendants to a valid document fragment.
 */
function normalizeDescendants(descendants) {
  const normalizedDescendants = [];
  if (Array.isArray(descendants)) {
    descendants.forEach(element => {
      if (Element.isElement(element)) {
        element.children = normalizeDescendants(element.children);
      }
      if (Node.isNode(element)) {
        normalizedDescendants.push(element);
      }
    });
  }
  if (!normalizedDescendants.length) {
    normalizedDescendants.push({
      text: ''
    });
  }
  return normalizedDescendants;
}
const isAncestor = node => Element.isElement(node) || Editor.isEditor(node);
/**
 * Recursively apply an operation to children nodes with a query.
 */
function applyDeepToNodes({
  node,
  source,
  apply,
  filter
}) {
  const entry = [node, []];
  if (entry && filter != null && filter(entry)) {
    apply(node, source);
  }
  if (!isAncestor(node)) return;
  node.children.forEach(child => {
    applyDeepToNodes({
      node: child,
      source,
      apply,
      filter
    });
  });
}

/**
 * Combine text nodes that can be joined together
 * Based loosely on https://github.com/ianstormtaylor/slate/blob/main/packages/slate-hyperscript/src/creators.ts#L27
 */
function combineTextDescendants(children) {
  return children.reduce((acc, child) => {
    const previousNode = acc[acc.length - 1];
    if (typeof child === 'string') {
      if (Text.isText(previousNode) && Object.keys(previousNode).length === 1) {
        previousNode.text += child;
        return acc;
      } else {
        // eslint-disable-next-line no-param-reassign
        child = {
          text: child
        };
      }
    }
    return [...acc, child];
  }, []);
}

export { applyDeepToNodes, combineTextDescendants, isAncestor, normalizeDescendants };
